module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Semibold.abd3050e.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Semibold.eot
// module id = 88
// module chunks = 3